import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@wartek-id/tabs'

import { DiktiPanel } from './components/TabNasional/DiktiPanel'
import { PaudDikdasmenPanel } from './components/TabNasional/PaudDikdasmenPanel'

export const DataIndukNasional = () => {
  return (
    <>
      <section id="tab-section">
        <Tabs defaultIndex={0} isFitted>
          <TabList className="container mx-auto">
            <Tab data-testid="tab-pauddikdasmen">PAUD DIKDASMEN</Tab>
            <Tab data-testid="tab-dikti">DIKTI</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <PaudDikdasmenPanel />
            </TabPanel>
            <TabPanel>
              <DiktiPanel />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </section>
    </>
  )
}
